<hmf-modal #paintedDoorModal
	(closed)="onClosePressed()">
	<header class="hmf-header-bold-m hmf-pt-0 hmf-pr-s">You're Ahead of the Game!</header>

	<p class="hmf-body-l">You've discovered a new feature we're gearing up to share soon!</p>

	<button hmf-button
		class="hmf-mt-xs"
		[variant]="'primary'"
		(click)="backToShopping()"
	>
		Go back to shopping
	</button>
</hmf-modal>
